<template>
  <div v-if="!loaded"></div>
  <div v-else>
    <div v-if="!isSoldOut" class="main-container">
      <div class="bread" v-if="!!$route.query.recommend">
        <router-link :to="{ name: 'Index' }">首页</router-link>
        <span class="slash">/</span>
        <router-link
          :to="{
            name: 'IndexRecommendClasses',
            query: {
              title: $route.query.title,
              recommend: $route.query.recommend,
            },
          }"
        >
          {{ $route.query.title }}
        </router-link>
        <span class="slash">/</span>
        <span class="current">{{ classes.title }}</span>
      </div>
      <div class="bread" v-else>
        <router-link :to="{ path: nav.url }">{{ nav.name }}</router-link>
        <span class="slash">/</span>
        <span class="current">{{ classes.name }}</span>
      </div>
      <ClassesDetailInfo
        :detail="classes"
        :couponList="couponList"
        @getCoupon="onGetCoupon"
      ></ClassesDetailInfo>
      <div class="classes-detail-main">
        <div class="classes-detail-left">
          <ClassesDetailTeachers :detail="classes"></ClassesDetailTeachers>
          <ClassesDetailTabs :detail="classes"></ClassesDetailTabs>
        </div>
        <ClassesDetailRecommend :recommendList="recommendList"></ClassesDetailRecommend>
      </div>
    </div>
    <CourseSoldOut v-else name="班级" routerName="Classes"></CourseSoldOut>
  </div>
</template>
<script>
import CourseSoldOut from '../../components/CourseSoldOut.vue';
import ClassesDetailInfo from '../../components/classes/ClassesDetailInfo.vue';
import ClassesDetailTeachers from '../../components/classes/ClassesDetailTeachers.vue';
import ClassesDetailTabs from '../../components/classes/ClassesDetailTabs.vue';
import ClassesDetailRecommend from '../../components/classes/ClassesDetailRecommend.vue';

export default {
  name: 'ClassesDetail',
  components: {
    CourseSoldOut,
    ClassesDetailInfo,
    ClassesDetailTeachers,
    ClassesDetailTabs,
    ClassesDetailRecommend,
  },
  data() {
    return {
      id: this.$route.params.id,
      loaded: false,
      isSoldOut: false,
      classes: {},
      couponList: [],
      recommendList: [],
    };
  },
  watch: {
    async $route() {
      this.id = this.$route.params.id;
      await this.getData();
    },
  },
  async created() {
    await this.getData();
  },
  computed: {
    navigates() {
      return this.$store.state.navigates;
    },
    nav() {
      let nav = this.navigates.filter((n) => n.id == this.$route.query.nav)[0];
      if (nav && nav.url != '/index') {
        nav = { ...nav };
        let url = nav.url;
        if (url.indexOf('?') < 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += 'nav=' + nav.id;
        nav.url = url;
        return nav;
      }
      return { name: '班级', url: '/classes' };
    },
  },
  methods: {
    async getData() {
      let data = await this.$http.get('/api/app/stateSchool/class/show/' + this.id);
      this.classes = data.info;
      this.couponList = data.coupon;
      this.recommendList = data.recommend;
      this.loaded = true;
    },
    async onGetCoupon(id) {
      let data = await this.$http.get('/api/app/userGetCoupon/' + id);
      this.couponList.filter((c) => c.id == id)[0].is_can_get = data.is_continue_get == 1 ? 1 : 0;
      this.$message({
        message: '领取成功',
        type: 'success',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.classes-detail-main {
  display: flex;
  justify-content: space-between;
  padding: 24px 0;
}
.classes-detail-left {
  width: 880px;
}
</style>
